import LoadingIndicator from "@ui/LoadingIndicator";
import ErrorIndicator from "@ui/ErrorIndicator";

import useVisualisationData from "./useVisualisationData";
import ViewerPageInternal from "./ViewerPageInternal";

const ViewerPage = () => {
  const { isLoading, metadata, config, localeData } = useVisualisationData();

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!metadata) {
    return <ErrorIndicator message="Error! Failed to load Metadata" />;
  }

  if (!config) {
    return (
      <ErrorIndicator message="Error! Failed to load Visualisation Config" />
    );
  }
  return (
    <ViewerPageInternal
      config={config}
      metadata={metadata}
      localeData={localeData}
    />
  );
};

export default ViewerPage;
